module.exports = __webpack_public_path__ + "static/media/zappyride-logo.23105b1c.svg";